export default "__VITE_ASSET__C3U0F4pk__"